// extracted by mini-css-extract-plugin
module.exports = {"user-info":"lHaA-pi","userInfo":"lHaA-pi","user-info-rating":"ebOD2OX","userInfoRating":"ebOD2OX","orders-in-queue":"MVAB71h","ordersInQueue":"MVAB71h"};